export default __webpack_public_path__ + "4e6ab4bf835325e33060339794edda6b.png";